import { gql } from "@apollo/client";

export const DETACH_POLICY = gql`
  mutation DetachPolicy($attachmentId: ID!) {
    policyDetach(id: $attachmentId) {
      id
    }
  }
`;
